import MinUpLoadImg from './MinUploadImg';
export default MinUpLoadImg;
